/* eslint-disable import/no-cycle */
import { Logger } from '@saviynt/common';

import {
  TAB_STATUS_ALL,
  TAB_STATUS_CONS,
  TAB_STATUS_DONE,
  TAB_STATUS_TODO,
} from '../../../components/ViewControls/CertsControlTabs/constant';
import { httpService } from '../../../http-service/httpService';
import { setViewApiError } from '../core/action';
import {
  axiosTimeoutConfig,
  SET_CERT_DETAILS_SELECTALL_COUNT,
  SET_CERT_TABS,
  SET_TAB_COUNTS_DISABLED,
  SET_TAB_COUNTS_ERROR,
  SET_TAB_COUNTS_LOADING,
  SET_TAB_COUNTS_SUCCESS,
  SET_TABHIGHLIGHT_NAME,
  tabMapping,
} from '../types';
import { URL_SELECT_ALL_API, URL_TAB_COUNT_API } from '../urls';

export const setCertsTabs = (tabs) => (dispatch) => {
  dispatch({
    type: SET_CERT_TABS,
    payload: { results: tabs },
  });
};

export const setTabsDisabled = (state) => (dispatch) => {
  dispatch({
    type: SET_TAB_COUNTS_DISABLED,
    payload: state,
  });
};

export const setTabHightLightKey = (tabToHighLight) => (dispatch) => {
  dispatch({
    type: SET_TABHIGHLIGHT_NAME,
    payload: tabToHighLight,
  });
};

export const getTabCounts =
  (certKey, isFirstTime = false) =>
  async (dispatch, getState) => {
    const body = { certkey: certKey };

    if (isFirstTime) {
      body.fetchAllCount = 'true';
    }

    const { tabData } = getState().certifications.details.tabs;

    const allTab = tabData?.find((item) => item.key === TAB_STATUS_ALL);

    dispatch({ type: SET_TAB_COUNTS_LOADING });

    try {
      const { data } = await httpService.post(URL_TAB_COUNT_API, body);
      // Map API response to the corresponding count based on the tab
      const consultedCount = data[`${tabMapping[TAB_STATUS_CONS]}Count`];
      const doneCount = data[`${tabMapping[TAB_STATUS_DONE]}Count`];

      dispatch({
        type: SET_TAB_COUNTS_SUCCESS,
        payload: {
          certKey,
          tab: TAB_STATUS_CONS,
          count: consultedCount || 0,
        },
      });

      dispatch({
        type: SET_TAB_COUNTS_SUCCESS,
        payload: {
          certKey,
          tab: TAB_STATUS_DONE,
          count: doneCount,
        },
      });

      if (isFirstTime) {
        const allCount = data[`${tabMapping[TAB_STATUS_ALL]}Count`];

        dispatch({
          type: SET_TAB_COUNTS_SUCCESS,
          payload: {
            certKey,
            tab: TAB_STATUS_ALL,
            count: allCount,
          },
        });
        dispatch({
          type: SET_TAB_COUNTS_SUCCESS,
          payload: {
            certKey,
            tab: TAB_STATUS_TODO,
            count: Math.max(allCount - doneCount - (consultedCount || 0), 0),
          },
        });
      } else {
        dispatch({
          type: SET_TAB_COUNTS_SUCCESS,
          payload: {
            certKey,
            tab: TAB_STATUS_TODO,
            count: Math.max(
              allTab.count - doneCount - (consultedCount || 0),
              0
            ),
          },
        });
      }
    } catch (error) {
      Logger.log('This is setting error - ', error);
      dispatch(setViewApiError(true));
      dispatch({
        type: SET_TAB_COUNTS_ERROR,
        payload: { error: error.message },
      });
    }
  };

export const getTotalCount = () => async (dispatch, getState) => {
  const {
    core: { totalItems },
    global: { certKey },
    tabs: { tabData },
  } = getState().certifications.details;

  // Get the active tab key
  const activeTabKey = tabData?.find((tab) => tab.isActive).key;
  const activeTab = tabMapping[activeTabKey] || 'all';

  const body = {
    certkey: certKey,
    tab: activeTab,
    requestOrigin: 'UI',
    onlyTotalCount: true,
  };

  try {
    const { data } = await httpService.post(
      URL_SELECT_ALL_API,
      body,
      axiosTimeoutConfig
    );

    dispatch({
      type: SET_CERT_DETAILS_SELECTALL_COUNT,
      payload: data.totalSelectedItems || totalItems,
    });
  } catch (error) {
    Logger.log('Error while updating count: - ', error);
  }
};
